<ng-container *transloco="let t; read: 'reports'">
<div class="p-5">
  <div>
    <drdp-title [title]="t('stateOsep.title')"></drdp-title>
    <div>
      <p>
        {{ t('stateOsep.description') }}
      </p>
    </div>
  </div>

  <drdp-container additionClasses="w-full mt-4">
    <drdp-container color="lightBlue">
      <form [formGroup]="searchForm">
        <div class="flex grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 md:gap-3 flex-row content-center mb-4">
          <div class="col-span-1 self-end">
            <drdp-select-state #stateSelect [initialStateId]="stateId.value" (state)="handleState($event)"
              [required]="true" [clear]="clearDropdown">
            </drdp-select-state>
          </div>
          <div class="col-span-1 self-end">
            <drdp-select-school-year #schoolYearSelect (schoolYear)="handleSchoolYear($event)" [clear]="clearDropdown"
              [required]="true">
            </drdp-select-school-year>
          </div>

        </div>
        <div class="flex flex-row gap-1.5 justify-end lg:col-span-2 xl:col-span-1 md:self-end xl:my-auto mt-4 md:mt-0">
          <div class="col-span-1">
            <drdp-btn [disabled]="!searchForm.valid" type="submit">
              <span class="px-2" (click)="showReport()">{{ t('stateOsep.showSummaryReport') }}</span>
            </drdp-btn>
          </div>
          <div class="col-span-1">
            <drdp-btn type="button" [disabled]="!searchForm.valid" (click)="downloadReport()">{{ t('stateOsep.downloadSummaryReport') }}</drdp-btn>
          </div>
          <div class="col-span-1">
            <drdp-btn type="button" [disabled]="!searchForm.valid" (click)="downloadDetailReport()">{{ t('stateOsep.downloadStateDetail') }}</drdp-btn>
          </div>
          <div class="col-span-1">
            <drdp-btn color="outline" (click)="handleClear()">{{ 'shared.actions.clear' | transloco }}</drdp-btn>
          </div>
        </div>
      </form>
    </drdp-container>
  </drdp-container>

  @if (!!reportData) {
    <div [innerHtml]="reportData! | safeHtml"></div>
  }

</div>
</ng-container>
